// extracted by mini-css-extract-plugin
export default {"link":"jK-z","disabled":"kK-z"};